<template>
  <div>

    <b-row>
      <!-- <b-col
          lg="12"
        >
          <div>
            <app-echart-bar
              :option-data="optionBar"
              style="width:auto; height:440px;"
            />
          </div>
        </b-col> -->
      <b-col cols="12">
        <app-echart-bar
          style="width:auto; height:440;"
          :option-data="optionBar"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {
  BRow, BCol,
  // BFormDatepicker, BFormSelect,
} from 'bootstrap-vue'
import axios from '@axios'
// import vSelect from 'vue-select'
import AppEchartBar from './AppEchartBar.vue'

const weatherIcons = {
  // eslint-disable-next-line global-require
  Car: require('@/assets/images/icons/db-progress-icons/car.png'),
  // eslint-disable-next-line global-require
  Pickup: require('@/assets/images/icons/db-progress-icons/pickup.png'),
  // eslint-disable-next-line global-require
  Taxi: require('@/assets/images/icons/db-progress-icons/taxi.png'),
  // eslint-disable-next-line global-require
  Truck: require('@/assets/images/icons/db-progress-icons/truck.png'),
  // eslint-disable-next-line global-require
  Trailer: require('@/assets/images/icons/db-progress-icons/trailer.png'),
  // eslint-disable-next-line global-require
  Motorcycle: require('@/assets/images/icons/db-progress-icons/motorcycle.png'),
  // eslint-disable-next-line global-require
  Bus: require('@/assets/images/icons/db-progress-icons/bus.png'),
}
const seriesLabel = {
  show: true,
}
export default {
  components: {
    BRow,
    BCol,
    AppEchartBar,
    // BFormDatepicker,
    // BFormSelect,
    // vSelect,
  },
  directives: {
    Ripple,
  },
  // props: {
  //   // ประกาศว่า props 'message' ถูกส่งจากพาเรนต์
  //   date: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  data() {
    return {
      optionBar: {
        title: {
          text: 'Weather Statistics',
        },
        grid: {
          left: 100,
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          splitLine: { show: false },
          type: 'value',
          name: '',
          axisLabel: {
            color: 'white',
            formatter: '{value}',
          },
        },
        yAxis: {
          splitLine: { show: false },
          type: 'category',
          inverse: true,
          data: ['CarCount', 'PickupCount', 'TaxiCount', 'TruckCount', 'TrailerCount', 'BikeCount', 'BusCount'],
          axisLabel: {
            fontSize: 14, // ขนาดข้อความ
            color: 'white',
            formatter(value) {
              const labelMap = {
                CarCount: 'รถยนต์',
                PickupCount: 'รถกระบะ',
                TaxiCount: 'รถแท็กซี่',
                TruckCount: 'รถบรรทุก',
                TrailerCount: 'รถพ่วง',
                BikeCount: 'มอเตอร์ไซค์',
                BusCount: 'บัส',
              }
              // ใช้ค่าใหม่จากอ็อบเจกต์แมป หากไม่มีการแมปให้ใช้ค่าเดิม
              return `{${value}| }   {value|${labelMap[value] || value}}`
            },
            margin: 20,
            rich: {
              CarCount: {
                height: 24,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.Car,
                },
                color: '#29C6CD',
              },
              PickupCount: {
                height: 29,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.Pickup,
                },
              },
              TaxiCount: {
                height: 29,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.Taxi,
                },
              },
              TruckCount: {
                height: 26,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.Truck,
                },
              },
              TrailerCount: {
                height: 25,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.Trailer,
                },
              },
              BikeCount: {
                height: 30,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.Motorcycle,
                },
              },
              BusCount: {
                height: 27,
                align: 'center',
                backgroundColor: {
                  image: weatherIcons.Bus,
                },
              },
            },
          },
        },
        series: [
          {
            name: '',
            type: 'bar',
            label: {
              show: seriesLabel, // แสดงป้ายชื่อ
              position: 'right', // ตำแหน่งป้ายชื่อ (inside, top, left, right, bottom)
              formatter(d) {
                return `${d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} คัน`
              },
              fontSize: 14, // ขนาดข้อความ
              color: 'white',
            },
            data: [],
            barMaxWidth: '10%',
            barMinWidth: '18px',
            itemStyle: {
              barBorderRadius: [0, 10, 10, 0],
              color(params) {
                const colors = {
                  0: '#29C6CD', // สำหรับ Car
                  1: '#FF90BC', // สำหรับ Pickup
                  2: '#F2EB00', // สำหรับ Taxi
                  3: '#CC9B6D', // สำหรับ Truck
                  4: '#7E94BF', // สำหรับ Trailer
                  5: '#B71375', // สำหรับ Motorcycle
                  6: '#3DC70A', // สำหรับ Bus
                }
                return colors[params.dataIndex] || '#5470c6'
              },
            },
          },
        ],
      },
      datetest: {
        datefrom: '2024-07-26',
        dateto: '2024-07-26',
        sta: '',
      },
      optionDirection: ['ทั้งหมด', 'ขาเข้า', 'ขาออก'],
      optionTime: [{ label: 'รายชั่วโมง', value: 'hourly' }, { label: 'รายวัน', value: 'daily' }, { label: 'รายเดือน', value: 'monthly' }, { label: 'รายปี', value: 'yearly' }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    monthList() {
      const years = []
      // eslint-disable-next-line no-plusplus
      for (let i = this.endMonth; i >= this.startMonth; i--) {
        years.push(i)
      }
      return years
    },
    yearList() {
      const years = []
      // eslint-disable-next-line no-plusplus
      for (let i = this.endYear; i >= this.startYear; i--) {
        years.push(i)
      }
      return years
    },
  },
  mounted() {
    // this.interval = setInterval(() => {
    //   this.getBarChart()
    // }, 600000)
    this.getBarChart()
  },
  methods: {
    resetBar() {
      // this.optionBar.xAxisData.splice(0)
      this.optionBar.series[0].data.splice(0)
    },
    // graphLine() {
    //   axios.post('/getLineCountDetail', { wid: this.$route.query.wid })
    //     .then(response => {
    //       this.xAxisData = []
    //       this.xAxisData = response.data
    //       this.xAxisData.forEach(value => {
    //         this.option.series[0].data.push(value.Total_PCU)
    //         this.option.series[0].data.push(value.Total_PCU)
    //         this.option.series[0].data.push(value.Total_PCU)
    //         this.option.series[0].data.push(value.Total_PCU)
    //         this.option.series[0].data.push(value.Total_PCU)
    //         this.option.series[0].data.push(value.Total_PCU)
    //       })
    //       console.log(114477, this.xAxisData)
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    graphLine() {
      axios.post('/getPercentCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.xAxisData = []
          this.xAxisData = response.data
          this.xAxisData.forEach(value => {
            this.option.xAxisData.push(value.Period_Name)
            this.option.series[0].data.push(value.Total_PCU)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getBarChart() {
      axios
        .post('/getPercentCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.xAxisData = []
          this.resetBar()
          this.xAxisData = response.data
          this.optionBar.series[0].data.push(response.data[0].Car_PCU)
          this.optionBar.series[0].data.push(response.data[0].Pickup_PCU)
          this.optionBar.series[0].data.push(response.data[0].Taxi_PCU)
          this.optionBar.series[0].data.push(response.data[0].Truck_PCU)
          this.optionBar.series[0].data.push(response.data[0].Trailer_PCU)
          this.optionBar.series[0].data.push(response.data[0].Bike_PCU)
          this.optionBar.series[0].data.push(response.data[0].Bus_PCU)
          console.log(555222, response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .style-chooser .vs__dropdown-toggle {
    border: 0px solid #000000 !important; /* Change #0000FF to the color you'd like on hover */
    background: #131313 !important;
  }
  .style-chooser .vs__dropdown-toggle .vs__search::placeholder {
    color: rgb(255, 255, 255);
    opacity: 1; /* ทำให้สีเห็นชัดเจนขึ้น */
  }
  </style>
